import { render } from "./discharge-graph-axis.vue?vue&type=template&id=4c835929&ts=true"
import script from "./discharge-graph-axis.vue?vue&type=script&lang=ts"
export * from "./discharge-graph-axis.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__